import { jsx, jsxs } from 'react/jsx-runtime';
import { DashboardSubheader } from './DashboardHeader.js';
import { AnimateChangeInHeight } from '@fabric-app/ui/components/animations/AnimateChangeInHeight';
import { ScrollArea } from '@fabric-app/ui/components/ScrollArea';
import { Flex } from '@fabric-app/ui/components/Flex';
import { ResourceSort } from '../../resources/components/ResourceSort.js';
import { ResourceFilterCreator } from '../../resources/components/Filters/ResourceFilterCreator.js';
import { ResourceFilterTag } from '../../resources/components/Filters/ResourceFilterTag.js';
import { ResourceFilterKind } from '../../resources/components/Filters/ResourceFilterKind/ResourceFilterKind.js';

const DashboardHeaderFilterSortResources = ({ visible, resourceId, creatorFilterHide = false, kindFilterDisabled = false, tagFilterDisabled = false, tagFilterHide = false }) => {
  return /* @__PURE__ */ jsx(AnimateChangeInHeight, {
    children: visible && /* @__PURE__ */ jsx(DashboardSubheader, {
      children: /* @__PURE__ */ jsx(ScrollArea.Default, {
        orientation: "horizontal",
        scrollbarVariant: "none",
        children: /* @__PURE__ */ jsx(DashboardSubheader.Body, {
          children: /* @__PURE__ */ jsxs(Flex, {
            gap: "elementsContainer",
            alignItems: "center",
            justifyContent: "space-between",
            flexGrow: true,
            children: [
              /* @__PURE__ */ jsxs(Flex, {
                gap: 12,
                alignItems: "center",
                justifyContent: "flex-start",
                flexGrow: true,
                children: [
                  /* @__PURE__ */ jsx(ResourceFilterKind, {
                    disabled: kindFilterDisabled
                  }),
                  !tagFilterHide && /* @__PURE__ */ jsx(ResourceFilterTag, {
                    disabled: tagFilterDisabled
                  }),
                  !creatorFilterHide && /* @__PURE__ */ jsx(ResourceFilterCreator, {
                    resourceId
                  })
                ]
              }),
              /* @__PURE__ */ jsx(ResourceSort, {})
            ]
          })
        })
      })
    })
  });
};

export { DashboardHeaderFilterSortResources };
//# sourceMappingURL=DashboardHeaderFilterSortResources.js.map
